// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2uojs","noInteraction":"EventWrapper_noInteraction__1bH_d","pointerPassthrough":"EventWrapper_pointerPassthrough__1sZEZ"};